import { get } from 'lodash';

export const getIPsLoading = state =>
  get(state, 'NetworkFilteringState.getIPs.loading');
export const getIPsResult = state =>
  get(state, 'NetworkFilteringState.getIPs.data');

export const getEnabledLoading = state =>
  get(state, 'NetworkFilteringState.getEnabled.loading');
export const getEnabledResult = state =>
  get(state, 'NetworkFilteringState.getEnabled.data');

export const setEnabledLoading = state =>
  get(state, 'NetworkFilteringState.setEnabled.loading');
export const setEnabledResult = state =>
  get(state, 'NetworkFilteringState.setEnabled.data');
export const setEnabledErrors = state =>
  get(state, 'NetworkFilteringState.setEnabled.errors');

export const postIPLoading = state =>
  get(state, 'NetworkFilteringState.postIP.loading');
export const postIPResult = state =>
  get(state, 'NetworkFilteringState.postIP.data');
export const postIPErrors = state =>
  get(state, 'NetworkFilteringState.postIP.errors');

export const getMyIPLoading = state =>
  get(state, 'NetworkFilteringState.getMyIP.loading');
export const getMyIPResult = state =>
  get(state, 'NetworkFilteringState.getMyIP.data');
export const getMyIPErrors = state =>
  get(state, 'NetworkFilteringState.getMyIP.errors');

export const postDeleteIPLoading = state =>
  get(state, 'NetworkFilteringState.postDeleteIP.loading');
export const postDeleteIPResult = state =>
  get(state, 'NetworkFilteringState.postDeleteIP.data');
export const postDeleteIPErrors = state =>
  get(state, 'NetworkFilteringState.postDeleteIP.errors');

export const getMyIPValidLoading = state =>
  get(state, 'NetworkFilteringState.getMyIPValid.loading');
export const getMyIPValidResult = state =>
  get(state, 'NetworkFilteringState.getMyIPValid.data');
export const getMyIPValidErrors = state =>
  get(state, 'NetworkFilteringState.getMyIPValid.errors');



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/state/selectors.js